<template>
	<div id='' class='gPageBorder' v-loading='loading'>
		<tyc :tqobj='tqobj'></tyc>
		<el-dialog class='' :title="$t('app_tip')" :visible.sync="cerDialogVisible" size="tiny" before-close="">
			<span>{{cerTipMsg}}</span>
			<span slot="footer" style='text-align:center'>
				<el-button @click="cerDialogVisible = false">{{$t('app_cancel')}}</el-button>
				<!-- <el-button type="primary" @click="pushCreateCer">{{$t()}}</el-button> -->
				<el-button type="primary" @click="pushUploadCer">{{$t('app_uploadCer')}}</el-button>
			</span>
		</el-dialog>

		<el-dialog class='' :title="$t('app_tip')" :visible.sync="cerTipDialogVisible" size="tiny" before-close="">
			<span>{{cerTipMsg}}</span>
			<span slot="footer" style='text-align:center'>
				<el-button type='primary' @click="cerTipDialogVisible = false">{{$t('app_sure')}}</el-button>
			</span>
		</el-dialog>


		<el-dialog class='gDia' :title="$t('app_addPush')" v-model="dialogVisible" size='middle'>
			<div v-loading='dvLoading'>
				<div style='width:100%;background:none;text-align:left;' class='gDiaTable'>

					<span>

						<el-select @change='selectDvChange' style='width:16%;margin-right:10px;' v-model="channelId"
							clearable :placeholder="$t('app_distributor')">
							<el-option v-for="item in channels" :key="item.mechanismid" :label="item.mechanismname"
								:value="item.mechanismid">
							</el-option>
						</el-select>
					</span>

					<span>

						<el-select @change='selectDvChange' style='width:16%;margin-right:10px;' v-model="status"
							clearable :placeholder="$t('app_status')">
							<el-option v-for="item in stModel" :key="item.vl" :label="item.label" :value="item.vl">
							</el-option>
						</el-select>
					</span>


					<el-input :placeholder="$t('app_searchTerminal')" icon="search" @keyup.enter.native='srchDevice'
						style='width:40%;margin-bottom:10px;' v-model="srchValue">
					</el-input>
				</div>




				<el-table :data="dvTableData" border tooltip-effect="dark" style="width: 100%">

					<el-table-column align='center' prop="terminalName" :label="$t('app_terName')" width="130">
					</el-table-column>

					<el-table-column align='center' prop="mechName" :label="$t('app_distributor')" width=''>
					</el-table-column>

					<el-table-column prop="terminal_status" align='center' :label="$t('app_status')" width="90">
						<template slot-scope="scope">
							<el-tag v-if="scope.row.terminalStatus == 1 " type="success"
								size="mini">{{$t('app_online')}}</el-tag>
							<el-tag v-if="scope.row.terminalStatus == 2 " type="danger"
								size="mini">{{$t('app_offline')}}</el-tag>
							<el-tag v-if="scope.row.terminalStatus == 0 " type="gray"
								size="mini">{{$t('app_new')}}</el-tag>
						</template>
					</el-table-column>

					<el-table-column prop="operate" :label="$t('app_operate')" align='right' header-align="center"
						width='80'>
						<template slot-scope='scope'>
							<!-- <el-button  @click='bindOperate(scope.row)' type=text>{{$t('app_push')}}</el-button> -->
							<el-tooltip class="item" effect="dark" :content="$t('app_push')" placement="top">
								<el-button type='text' @click='bindOperate(scope.row)'><i class="fa fa-upload"
										style=""></i></el-button>
							</el-tooltip>
						</template>
					</el-table-column>
				</el-table>

				<div class="block" style=''>

					<el-pagination @current-change="pageDvSelect" @size-change="pageDvSized" :current-page="dvIndex"
						:page-sizes='$gRows' :page-size="$gRow" layout="total, sizes, prev, pager, next, jumper"
						:total="dvTotal">
					</el-pagination>
					<!-- <el-pagination
          small
          layout="prev, pager, next"
          :total="dvTotal">
        </el-pagination> -->

				</div>
			</div>
		</el-dialog>

		<div id=''>
			<div style=''>

				<el-row>
					<el-col :span="8" class=''>
						<el-button class='gSgLeftBtn' type='primary'
							@click='jumpToUpload'>{{$t('app_addfile')}}</el-button>
					</el-col>


					<el-col :span="4">
						<div class='gCtrl'>
							<el-select clearable="" v-model="ftype" :placeholder="$t('app_filetype')"
								@change='fileTypeChange'>
								<el-option v-for="item in ftypes" :key="item.vl" :label="item.lb" :value="item.vl">
								</el-option>
							</el-select>

						</div>
					</el-col>


					<el-col :span="4">
						<div class='gCtrl'>
							<el-select v-model="sftype" clearable :placeholder="$t('app_subtype')" @change='getList()'>
								<el-option v-for="item in cmsts" :key="item.vl" :label="item.lb" :value="item.vl">
								</el-option>
							</el-select>

						</div>
					</el-col>


					<el-col :span="4">
						<div class='gCtrl'>

							<MechanismSelector style='' :data="mechanismData"></MechanismSelector>
						</div>
					</el-col>


					<el-col :span="4">
						<div class='gSideCtrl'>
							<el-input :placeholder="$t('app_name')" v-model='queryKey' @keyup.enter.native='query'
								icon="search" :on-icon-click="query"></el-input>
						</div>
					</el-col>

				</el-row>


			</div>
		</div>


		<!-- <div id='adFilter' v-show=0>
      <label>{{$t('app_filter')}}:</label>
      <el-select style='width:16%;margin-left:20px;' v-model="appTypeValue" clearable :placeholder="$t('app_type')">
        <el-option
          v-for="item in appTypes"
          :key="item.appClassifyId"
          :label="item.appClassifyName"
          :value="item.appClassifyId">
        </el-option>
      </el-select>
      <el-select style='width:16%;margin-left:20px;' v-model="appStatusValue" clearable :placeholder="$t('app_status')">
        <el-option
          v-for="item in appStatus"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
    </div> -->

		<div id=''>
			<el-table @row-click='cellClick' :data="tableData" border @sort-change="sortChange" class='tbPoint gTopMg'
				style="width: 100%;border:none;">

				<el-table-column header-align='center' align='center' sortable="custom" prop="fileName"
					:label="$t('app_filename')" width="">
				</el-table-column>

				<el-table-column header-align='center' align='center' prop="fileVersion" width=''
					:label="$t('app_version')">
				</el-table-column>

				<el-table-column header-align='center' align='center' prop="fileType" :formatter="setft" width='115'
					:label="$t('app_filetype')">
				</el-table-column>

				<el-table-column header-align='center' align='center' prop="subFileType" :formatter="setsbt" width='120'
					:label="$t('app_subtype')">
				</el-table-column>

				<el-table-column header-align='center' align='center' prop="mechName" width=''
					:label="$t('app_distributor')">
				</el-table-column>

				<el-table-column header-align='center' align='center' prop="fileStatus" width='115'
					:label="$t('app_vStatus')">
					<template slot-scope='scope'>
						<label
							:style='getStatus(scope.row.fileStatus).style'>{{getStatus(scope.row.fileStatus).vl}}</label>
					</template>
				</el-table-column>

				<el-table-column header-align='center' align='center' prop="createTime" sortable="custom" width='175'
					:label="$t('app_addtime')">
				</el-table-column>

				<el-table-column header-align='center' align='right' prop="operate" width='122'
					:label="$t('app_operate')">
					<template slot-scope='scope'>

						<span style='background:none;'>

							<!-- <el-button v-show="scope.row.fileStatus === '2'" type=text @click='pushApp(scope.row)'>{{$t('app_push')}}</el-button> -->
							<!-- <el-button v-show="(scope.row.fileStatus !== '1' && scope.row.fileStatus !== '2') && scope.row.isoperate === 0" type=text @click='editApp(scope.row)'>{{$t('app_edit')}}</el-button> -->

							<el-tooltip class="item" effect="dark" :content="$t('lin_btn.send')" placement="top">
								<el-button v-show="scope.row.fileStatus == 2" type=text @click='pushApp(scope.row)'><i
										class="fa fa-upload" style=""></i></el-button>
							</el-tooltip>

							<el-tooltip class="item" effect="dark" :content="$t('app_edit')" placement="top">
								<el-button v-show="(scope.row.fileStatus != '1' && scope.row.fileStatus != '2') "
									type=text @click='editApp(scope.row)'><i class="fa fa-pencil"
										style=""></i></el-button>
							</el-tooltip>

							<el-tooltip class="item" effect="dark" :content="$t('app_down')" placement="top">
								<el-button type='text' @click='downOldApp(scope.row)'><i class="fa fa-download"
										style=""></i></el-button>
							</el-tooltip>

							<!-- <el-button v-show="scope.row.fileStatus !== '1' && scope.row.fileStatus !== '2' && scope.row.isoperate === 0" @click='submitApp(scope.row)' type='text'>{{$t('app_smVerify')}}</el-button> -->
							<el-tooltip class="item" effect="dark" :content="$t('app_smVerify')" placement="top">
								<el-button v-show="scope.row.fileStatus != '1' && scope.row.fileStatus != '2' "
									@click='submitApp(scope.row)' type='text'><i class="fa fa-external-link-square"
										style=""></i></el-button>
							</el-tooltip>

							<!-- <el-button v-show='scope.row.isoperate === 0' type=text @click='deleteApp(scope.row)'>{{$t('app_del')}}</el-button> -->
							<el-tooltip class="item" effect="dark" :content="$t('app_del')" placement="top">
								<el-button type='text' v-show='true' @click='deleteApp(scope.row)'><i
										class="fa fa-trash-o" style="color:#FF4949"></i></el-button>
							</el-tooltip>

						</span>
					</template>
				</el-table-column>
			</el-table>

			<div class="gPgDiv" style=''>
				<el-pagination class='gPg' @current-change="pageSelect" @size-change="pageSized" :current-page="index"
					:page-sizes='$gRows' :page-size="$gRow" layout="total, sizes, prev, pager, next, jumper"
					:total="total">
				</el-pagination>
			</div>
		</div>

	</div>
</template>

<style>
	/* html,body{width:100%;height:100%;}*/

	.tbPoint td {
		cursor: pointer
	}

	.cmMarginFrame {
		width: calc(100% - 20px);
		height: 100%;
		background: none;
		margin-left: 10px;
	}

	#appDepot {
		min-width: 840px;
	}

	#adData {}
</style>

<script>
	import MechanismSelector from '@/components/global/mechanism_selector.vue'
	import mm from 'moment'
	import tyc from '@/components/global/tyc.vue'
	export default {

		data() {
			var that = this
			return {
				orderName: '',
				orderType: '',
				tqobj: '',
				mechanismData: {
					callback(value) {
						// that.mech = value
						that.selectChange(value)
					}
				},
				listKey: 'launch-list',
				cerDialogVisible: false,
				cerTipDialogVisible: false,
				dvLoading: 0,
				index: 1,
				appId: '',
				stModel: [{
						label: this.$t('app_online'),
						vl: '1'
					},
					{
						label: this.$t('app_offline'),
						vl: '2'
					},
					{
						label: this.$t('app_new'),
						vl: '0'
					}
				],
				channels: [],
				cmsts: [],
				srchValue: '',
				channelId: '',
				cerTipMsg: '',
				status: '',
				dvIndex: 1,
				ftype: '',
				sftype: '',
				dialogVisible: 0,
				mechanismId: window.localStorage['mechanismId'],
				selectMid: '',
				tableData: [],
				dvTableData: [],
				appTypes: [],
				appTypeValue: '',
				appStatus: [{
						label: this.$t('app_prePushVerify'),
						value: '0'
					},
					{
						label: this.$t('app_preVerify'),
						value: '1'
					},
					{
						label: this.$t('app_verifyPass'),
						value: '2'
					},
					{
						label: this.$t('app_verifyNotPass'),
						value: '3'
					}
				],
				appStatusValue: '',
				total: 0,
				dvTotal: 0,
				loading: 0,
				appType: '',
				queryKey: '',
				ftypes: '',
				getftype: '',
				sftypes1: [],
				sftypes2: [],
				sftypes3: [],
				sftypes5: [],
				sftypes6: [],
				sftypes7: [],
				sftypes9: [],
				sftypes10: [],
				sftypes11: [],
				getsftype: ''
			}
		},
		components: {
			MechanismSelector,
			tyc
		},
		computed: {
			index() {
				var vl = this.$getWPage(this.listKey)
				return vl ? vl : 1
			},
			getDvStatus(value) {
				switch (value) {
					case '0':
						return this.$t('app_prePushVerify')
					case '1':
						return this.$t('app_preVerify')
					case '2':
						return this.$t('app_verifyPass')
					case '3':
						return this.$t('app_verifyNotPass')
				}
			}
		},
		methods: {
			sortChange(vl) {
				switch (vl.prop) {
					case 'fileName':
						this.orderName = '1'
						break
					case 'createTime':
						this.orderName = '2'
						break
				}
				this.orderType = vl.order == 'descending' ? 'desc' : 'asc'
				this.getList()
			},
			fileTypeChange(vl) {
				this.sftype = ''
				if (!vl) {
					this.cmsts = ''
				} else
					this.cmsts = this['sftypes' + vl]
				this.getList()
			},
			setft(row) {
				return this.getftype[row.fileType]
			},
			setsbt(row) {

				var vl = this.getsftype[row.subFileType]
				// console.log(row.subFileType, vl)
				return vl

				// return this.getsftype["6-1"]
			},
			pushCreateCer() {
				this.$router.push({
					path: "/certificate/new"
				})
			},
			pushUploadCer() {
				this.$router.push({
					path: "/certificate/upload"
				})
			},
			bindOperate(row) {
				//console.log(row)

				this.dvLoading = 1
				if (this.$appUrlTag === 0) {
					this.$bindApp('0', row.terminalNo, this.appId, (res) => {
						if (res.status === 200) {
							this.$message.success(this.$t('app_tipViewTask'))
						} else {
							this.$message.error(res.message)
						}
						this.dvLoading = 0
					}, () => {
						// error
						this.dvLoading = 0
					})
				} else {
					// console.log(localStorage.mechanismId, tNo)
					this.$bindApp1(localStorage.mechanismId, row.terminalNo, this.appId, (res) => {
						if (res.status === 200) {
							this.$message.success(this.$t('app_tipViewTask'))
						} else {
							this.$message.error(res.message)
						}
						this.dvLoading = 0
					}, () => {
						// error
						this.dvLoading = 0
					})
				}
			},
			getChannels() {
				this.$getChannelList(10000, 1, '', '', '', (res) => {
					if (res.status === 200) {
						this.channels = res.data
					} else {
						this.$message.error(res.message)
					}
				}, () => {
					// error
					this.$message.error(this.$t('app_rqsError'))
				})
			},
			downOldApp(row) {
				// console.log(this.$host)
				// window.open(this.$host + row.appUrl)
				// let base_url = "http://218.17.164.125:8686"
				window.open(this.$host + row.fileUrl)
			},
			getStatus(value) {
				if (!value) return ''
				switch (value) {
					case '0':
						return {
							vl: this.$t('app_prePushVerify'), style: 'color:#8492A6;'
						}
					case '1':
						return {
							vl: this.$t('app_preVerify'), style: 'color:#F7BA2A;'
						}
					case '2':
						return {
							vl: this.$t('app_verifyPass'), style: 'color:#13CE66;'
						}
					case '3':
						return {
							vl: this.$t('app_verifyNotPass'), style: 'color:#FF4949;'
						}
				}
			},
			srchDevice() {
				this.getDevices()
			},
			selectDvChange(vl) {
				this.getDevices()
			},
			pageDvSized(val) {
				this.$gRow = val
				this.getDevices()
			},
			getDevices() {
				var vl = this.srchValue ? this.srchValue : ''
				var channel = this.channelId ? this.channelId : ''
				var status = this.status ? this.status : ''
				var appId = this.appId ? this.appId : ''
				this.dvLoading = 1
				if (this.$appUrlTag === 0) {
					this.$getDevices(this.dvIndex, this.$gRow, channel, vl, status, '', appId, (res) => {
						// console.log('dv', res)
						this.dvLoading = 0
						if (res.data) {
							this.dvTableData = res.data
							this.dvTotal = res.total
						}
					}, () => {
						// error
						this.dvLoading = 0
					})
				} else {

					this.$getDevices1(this.dvIndex, this.$gRow, localStorage.mechanismId, vl, status, '', appId, (res) => {
						console.log('dv', res)
						this.dvLoading = 0
						if (res.data) {
							this.dvTableData = res.data
							this.dvTotal = res.total
						}
					}, () => {
						// error
						this.dvLoading = 0
					})
				}

			},
			editApp(row) {
				this.$setWObj('fileEdit', {
					type: 1,
					data: row
				})
				this.$router.push({
					path: '/filemg/edit'
				})
			},
			pushApp(row) {

				// this.$setWObj('filePush', row)
				// this.$router.push({path: '/filemg/push'})

				this.$router.push({
					path: '/task/ptask/new',
					query: {
						mode: 2,
						fname: row.fileName,
						ftype: row.fileType,
						fid: row.fileId
					}
				})

			},
			query() {
				this.getList()
			},
			selectChange(vl) {
				this.selectMid = vl
				this.getList()
			},
			reset() {
				this.queryKey = ''
				this.appType = ''
				this.getList()
			},
			pageSelect(index) {
				// this.$setWPage(this.listKey, index)
				this.index = index
				this.getList()
			},
			pageDvSelect(index) {
				this.dvIndex = index
				this.getDevices()
			},
			pageSized(val) {
				this.$gRow = val
				this.getList()
			},
			deleteApp(obj) {
				this.$showConfirm(this.$t('app_tip'), this.$t('app_isDelData'), this.$t('app_sure'), this.$t('app_cancel'),
					'warning', () => {
						// console.log(obj)

						this.$delfile(obj.fileId, (res) => {
							if (res.status == 200) {
								this.getList()
								this.$message.success(res.message)
							} else {
								this.$message.error(res.message)
							}
						}, '')
					}, '')
			},
			submitApp(obj) {
				this.$showConfirm(this.$t('app_tip'), this.$t('app_tipVerify'), this.$t('app_sure'), this.$t('app_cancel'),
					'warning', () => {
						this.loading = 1
						this.$verifyFile(obj.fileId, '', '1', (res) => {
							this.loading = 0
							if (res.status === 200) {
								this.getList()
								this.$message.success(res.message)
							} else {
								this.$message.error(res.message)
							}
						}, () => {
							this.loading = 0
						})

					}, '')
			},
			cellClick(row, ev, col) {
				if (col.label && col.label === this.$t('app_operate')) {
					return
				}

				//console.log(row)
				// var isDetail = (row.status === '1' || row.status === '2')
				// var path = isDetail ? '/launch-detail' : '/launch-edit'
				// var key = isDetail ? 'launcherDetail' : 'launcherEdit'
				// var obj = isDetail ? row : {type: 1, data: row}

				// this.$setWObj(key, obj)
				// this.$router.push({path: path})

			},
			jumpToUpload() {

				this.$setWObj('fileEdit', {
					type: 0
				})
				this.$router.push({
					path: '/filemg/add'
				})
			},
			getList() {
				this.loading = 1
				var mech = this.selectMid ? this.selectMid : '' //渠道商id
				var name = this.queryKey ? this.queryKey : ''
				var type = this.ftype
				var stype = this.sftype
				var st = ''

				this.$getfile(this.index, this.$gRow, name, mech, type, stype, st, this.orderName, this.orderType, (
				res) => {

					this.loading = 0
					if (res.status === 200) {
						this.total = res.total
						this.tableData = res.data
					} else {
						this.$message(res.message)
					}
				}, () => {
					this.loading = 0
					this.$message.error(this.$t('app_rqsError'))
				})
			},
			dateFormat(row, column) {
				var date = row[column.property]
				if (date === undefined) {
					return ''
				}
				return mm(date).format('YYYY-MM-DD HH:mm:ss')
			},
			setInstallType(type) {
				return this.$installType[type]
			}
		},
		mounted() {

			this.tqobj = {
				keys: ['ftypes', 'ftype', 'sftype', 'sftypes1', 'sftypes2', 'sftypes3', 'sftypes4', 'sftypes5',
					'sftypes6', 'sftypes7', 'sftypes9', 'sftypes11'
				],
				callback: (data) => {
					console.log(data)
					this.ftypes = data[0]
					this.ftypes.splice(3, 1)
					this.ftypes.splice(5,1)

					this.getftype = data[1]
					this.getsftype = data[2]
					this.sftypes1 = data[3]
					this.sftypes2 = data[4]
					this.sftypes3 = data[5]
					this.sftypes4 = data[6]
					this.sftypes5 = data[7]
					this.sftypes6 = data[8]
					this.sftypes7 = data[9]
					this.sftypes9 = data[10]
					this.sftypes11 = data[11]
				}
			}
			// helper.say()
			//this.getChannels()
			this.getList()
			/*this.$getAppTypeList(100000000, 1, (res) => {
			  if (res.status === 200) {
			    this.appTypes = res.data
			  } else {
			    this.$message(res.message)
			  }
			}, '')*/
		},
		destroyed() {}
	}
</script>


// WEBPACK FOOTER //
// list.vue?ea0efb7c